
import React, { useState, useEffect } from 'react';


function Outstock() {
  const [heading, setHeading] = useState('');
  const [material, setMaterial] = useState('');
  const [materialOptions, setMaterialOptions] = useState([]);
  const [totalQuantityInStock, setTotalQuantityInStock] = useState(null); 

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [quantity, setQuantity] = useState('');
  const [peritem, setPerItem] = useState('');
  const [TeacherName, setTeacherName] = useState('');
  const [tamount, setTamount] = useState('');
  const [date, setDate] = useState('');
  const [remark, setRemark] = useState('');
  const [headings, setHeadings] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState({});
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [editingKey, setEditingKey] = useState(null);
  const [filteredData, setFilteredData] = useState({});
  const [schoolName, setSchoolName] = useState("");
  const [taluka, setTaluka] = useState("");
    const [selectedClass, setSelectedClass] = useState('');
  const [jilha, setJilha] = useState("");
  const [logoURL, setLogoURL] = useState(null);
  const language = localStorage.getItem("language") || "English"
  const [showModal, setShowModal] = useState(true);
  const [classes, setClasses] = useState([]); 
 

  useEffect(() => {
    // Get today's date
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // Format to yyyy-MM-dd
    setDate(formattedDate); // Set the default date
  }, []);

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        
      };
    });
  };

  useEffect(() => {
    // Fetch categories from the instock node
    const fetchCategories = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['inventory'], 'readonly');
        const objectStore = transaction.objectStore('inventory');
        const allRecords = objectStore.getAll();
  
        allRecords.onsuccess = (event) => {
          const data = event.target.result;
          console.log("data", data);
  
          // Ensure data is an object and filter out null values
          const categories = new Set();
          Object.values(data).forEach(item => {
            Object.keys(item.value).forEach(key => {
              if (item.value[key] && item.value[key].Heading) {
                categories.add(item.value[key].Heading);
              }
            });
          });
  
          console.log("categories", categories);
          setCategoryOptions([...categories]); // Set unique categories
          console.log("categoryOptions", categoryOptions);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, [udiseNumber]);

  const openDatabase = async () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        // Create object store with a key path
        if (!db.objectStoreNames.contains('inventory')) {
          const store = db.createObjectStore('inventory', { keyPath: 'id' }); // Ensure 'id' is the key path
          store.createIndex('key', 'key', { unique: false });
        }
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };
  
 const handleQuantityChange = (event) => {
    let enteredQuantity = event.target.value;
console.log("enteredQuantity",enteredQuantity);
    // Prevent non-numeric values
    if (!/^\d*$/.test(enteredQuantity)) return;

    // Prevents negative values
    if (parseInt(enteredQuantity) < 0) {
      alert("Quantity cannot be negative.");
      return;
    }

    // Prevents exceeding available stock
    if (totalQuantityInStock !== null && parseInt(enteredQuantity) > totalQuantityInStock) {
      alert(`Only ${totalQuantityInStock} available in stock.`);
      return;
    }

    setQuantity(enteredQuantity); // ✅ Set only valid quantity
  };

  const fetchTotalQuantityFromIndexedDB = async () => {
    const db = await openDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('inventory', 'readonly');
      const store = transaction.objectStore('inventory');
      const request = store.get('instock'); // Fetch the 'instock' key
  
      request.onsuccess = (event) => {
        const result = event.target.result;
        console.log("result--", result);

        
        if (result && Array.isArray(result.value)) {
          const totalQuantity = result.value.reduce((acc, item) => {
            // Check if item is not null and has the required properties
            if (item && item.Heading === heading && item.Material === material) {
              return acc + (Number(item.TotalQuantity) || 0); // Add TotalQuantity if it exists
            }
            return acc; // Otherwise, return the accumulated value
          }, 0);
          resolve(totalQuantity);
        } else {
          resolve(0); // Return 0 if not found or if result is not an array
        }
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };


  useEffect(() => {
    const fetchTotalQuantity = async () => {
      try {
        const totalQuantity = await fetchTotalQuantityFromIndexedDB();
        setTotalQuantityInStock(totalQuantity); // Update state with the fetched total quantity
      } catch (error) {
        console.error("Error fetching total quantity from IndexedDB:", error);
        setTotalQuantityInStock(0); // Prevent undefined values
      }
    };
  
    if (material && heading) {
      fetchTotalQuantity();
    }
  }, [material, heading, udiseNumber]);


  const fetchMaterialsFromIndexedDB = async () => {
    const db = await openDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('inventory', 'readonly');
      const store = transaction.objectStore('inventory');
      const request = store.get('instock'); // Fetch the 'instock' key
  
      request.onsuccess = (event) => {
        const result = event.target.result;
        if (result && Array.isArray(result.value)) {
          // Filter materials based on the selected heading
          const materials = result.value
            .filter(item => item && item.Heading === heading) // Ensure item is not null and matches heading
            .map(item => item.Material); // Extract materials
          resolve([...new Set(materials)]); // Return unique materials
        } else {
          resolve([]); // Return an empty array if not found or if result is not an array
        }
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };
  
  useEffect(() => {
    // Fetch materials based on the selected category
    const fetchMaterials = async () => {
      if (heading) {
        try {
          const materials = await fetchMaterialsFromIndexedDB();
          setMaterialOptions(materials); // Set unique materials
        } catch (error) {
          console.error('Error fetching materials from IndexedDB:', error);
        }
      } else {
        setMaterialOptions([]); // Clear materials if no heading is selected
      }
    };
  
    fetchMaterials();
  }, [heading, udiseNumber]);
  useEffect(() => {
    // Calculate Total Amount when Quantity or Per Item Amount changes
    if (quantity && peritem) {
      const total = parseFloat(quantity) * parseFloat(peritem);
      setTamount(total);
    }
  }, [quantity, peritem]);
  
  useEffect(() => {
    // Calculate Per Item Amount when Total Amount and Quantity changes
    if (tamount && quantity) {
      const perItemAmount = parseFloat(tamount) / parseFloat(quantity);
      setPerItem(perItemAmount);
    }
  }, [tamount, quantity]);

  const romanToInt = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };
  
  const marathiToInt = {
    'पहिली': 1,
    'दुसरी': 2,
    'तिसरी': 3,
    'चौथी': 4,
    'पाचवी': 5,
    'सहावी': 6,
    'सातवी': 7,
    'आठवी': 8,
    'नववी': 9,
    'दहावी': 10,
    'अकरावी':11,
    'बारावी': 12
  };

  
  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
  };

  useEffect(() => {
    const fetchClassDivData = async () => {
      try {
        const storedDivClasses = localStorage.getItem("classDiv");
        if (storedDivClasses) {
          const data = JSON.parse(storedDivClasses);
          
          const classList = [];
          // const divisionList = {};
    
          for (const [className, value] of Object.entries(data)) {
            if (value === true) {
              // Class without divisions
              classList.push(className);
              // divisionList[className] = []; 
            } else if (typeof value === 'object') {
              // Class with divisions
              classList.push(className);
              // divisionList[className] = Object.keys(value).filter(div => value[div]);
            }
          }
    
          setClasses(classList);
        }
      } catch (error) {
        console.error("Error fetching classDiv data: ", error);
      }
    };
    
    fetchClassDivData();
  }, [udiseNumber]);


  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0'); 
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear(); 
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
      const data = await fetchOutStockData();
      
      console.log("data", data);
        setData(data); // Store the full data
  
        // Extract unique headings from SchoolDistribution
        if (data) {
          const headingsFromDistribution = Object.values(data)
            .filter((item) => item && item.Heading) // Ensure item is not null and has a Heading property
            .map((item) => item.Heading);
          const uniqueHeadings = [...new Set(headingsFromDistribution)];
          setHeadings(uniqueHeadings); // Set the unique headings
        }
  
        // Filter data based on the selected heading
        if (heading && data) {
          const filtered = Object.keys(data).reduce((acc, key) => {
            if (data[key] && data[key].Heading === heading) {
              acc[key] = data[key];
            }
            return acc;
          }, {});
          setFilteredData(filtered);
        } else {
          setFilteredData(data || {}); // If no heading is selected, show all data (or an empty object if data is null)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [udiseNumber, heading]); 


 const fetchOutStockData = async () => {
    const db = await openDatabase();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('inventory', 'readonly');
      const store = transaction.objectStore('inventory');
      const request = store.get('outstock'); // Fetch the 'instock' key
  
      request.onsuccess = (event) => {
        const result = event.target.result;
        console.log("result",result);
        
        if (result) {
          resolve(result.value); // Return the value array
        } else {
          resolve([]); // Return an empty array if not found
        }
      };
  
      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  };

  const updateExistingDataInIndexedDB = async (newData) => {
    try {
      const db = await openDatabase();  // Ensure the DB is opened successfully
      const transaction = db.transaction('inventory', 'readwrite');
      const store = transaction.objectStore('inventory');
  
      // Fetch the existing outstock data
      const getRequest = store.get('outstock');
  
      getRequest.onsuccess = (event) => {
        let existingData = event.target.result?.value || {}; // If no data, start with an empty object
  
        // Update the existing data
        existingData[newData.id] = newData;
  
        // Save the updated outstock data back to IndexedDB
        const putRequest = store.put({
          id: 'outstock',
          key: 'outstock', // We use 'outstock' as the key to hold all outstock records
          value: existingData, // Updated outstock data
        });
  
        putRequest.onsuccess = () => {
          console.log('Existing data updated in IndexedDB');
        };
  
        putRequest.onerror = (event) => {
          console.error('Error updating existing data in IndexedDB:', event.target.error);
        };
      };
  
      getRequest.onerror = (event) => {
        console.error('Error fetching outstock data:', event.target.error);
      };
  
      await new Promise((resolve, reject) => {
        transaction.oncomplete = resolve;
        transaction.onerror = reject;
      });
    } catch (error) {
      console.error('Error updating existing data in IndexedDB:', error);
    }
  };


const saveToIndexedDB = async (newData) => {
    try {
      const db = await openDatabase();  // Ensure the DB is opened successfully
      const transaction = db.transaction('inventory', 'readwrite');
      const store = transaction.objectStore('inventory');
  
      // Fetch the existing outstock data
      const getRequest = store.get('outstock');
  
      getRequest.onsuccess = (event) => {
        let existingData = event.target.result?.value || {}; // If no data, start with an empty object
  
        // Append the new entry using its unique ID as the key
        const outstockData = {
          ...existingData, // Keep the existing data
          [newData.id]: newData, // Add the new data with the unique ID
        };
  
        // Save the updated outstock data back to IndexedDB
        const putRequest = store.put({
          id: 'outstock',
          key: 'outstock', // We use 'outstock' as the key to hold all outstock records
          value: outstockData, // Updated outstock data
        });
  
        putRequest.onsuccess = () => {
          console.log('Outstock data updated in IndexedDB');
        };
  
        putRequest.onerror = (event) => {
          console.error('Error updating outstock data in IndexedDB:', event.target.error);
        };
      };
  
      getRequest.onerror = (event) => {
        console.error('Error fetching outstock data:', event.target.error);
      };
  
      await new Promise((resolve, reject) => {
        transaction.oncomplete = resolve;
        transaction.onerror = reject;
      });
  
    } catch (error) {
      console.error('Error saving to IndexedDB:', error);
    }
  };
  
  const handlesave = async (event) => {
  event.preventDefault();

  if (!date?.trim() || !heading?.trim() || !material?.trim() || !quantity) {
    alert("Date, Heading, Material, and Quantity must be filled in.");
    return;
  }

  setSaving(true);

  const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/outstock.json`;
  const inStockUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/instock.json`;

  try {
    // Fetch in-stock data
    const inStockResponse = await fetch(inStockUrl, { method: 'GET' });
    if (!inStockResponse.ok) throw new Error(`Failed to fetch in-stock items: ${inStockResponse.statusText}`);

    const inStockData = await inStockResponse.json() || {};

    let productId = null;
    let totalQuantityInStock = 0;
    for (const [key, item] of Object.entries(inStockData)) {
      if (item?.Heading === heading && item?.Material === material) {
        productId = key;
        totalQuantityInStock = item.TotalQuantity;
        break;
      }
    }

    if (!productId) {
      alert(`No product found with Heading "${heading}" and Material "${material}" in stock.`);
      setSaving(false);
      return;
    }

    const parsedQuantity = parseInt(quantity);
    if (parsedQuantity > totalQuantityInStock) {
      alert(`Only ${totalQuantityInStock} available in stock. Reduce the quantity.`);
      setQuantity(totalQuantityInStock.toString());
      setSaving(false);
      return;
    }

    const updatedQuantity = totalQuantityInStock - parsedQuantity;

    // Update in-stock data
    await fetch(inStockUrl, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ [productId]: { ...inStockData[productId], TotalQuantity: updatedQuantity } }),
    });

    // Fetch existing outstock data
    const response = await fetch(url, { method: 'GET' });
    if (!response.ok) throw new Error(`Failed to fetch outstock data: ${response.statusText}`);

    const data = (await response.json()) || {};

    if (editingKey) {
      // Update existing data
      const outstockData = {
        Remark: remark?.trim() || "",
        Class: selectedClass?.trim() || "",
        Quantity: parsedQuantity,
        TeacherName: TeacherName?.trim() || "", 
        Heading: heading?.trim() || "",
        Material: material?.trim() || "",
        date: date?.trim() || "",
        id: editingKey, // Use the existing id
      };

      // Update existing data in IndexedDB
      await updateExistingDataInIndexedDB(outstockData);

      // Update existing data in
      const updatedData = { ...data };
      delete updatedData[editingKey];
      updatedData[editingKey] = outstockData;
      await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedData),
      });
    } else {
      // Create new data
      const uniqueKey = `${productId}&&${formatDate(date)}&&${Object.keys(data).length + 1}`;
      const outstockData = {
        Remark: remark?.trim() || "",
        Class: selectedClass?.trim() || "",
        Quantity: parsedQuantity,
        TeacherName: TeacherName?.trim() || "", 
        Heading: heading?.trim() || "",
        Material: material?.trim() || "",
        date: date?.trim() || "",
        id: uniqueKey, // Generate a new id
      };

      // Save to IndexedDB
      await saveToIndexedDB(outstockData);

      // Save to
      await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, [uniqueKey]: outstockData }),
      });
    }

    setSaving(false);

    // Reset form fields
    setHeading('');
    setMaterial('');
    setSelectedClass('');
    setTeacherName('');
    setQuantity('');
    setTamount('');
    setDate('');
    setTotalQuantityInStock(null);
    setRemark('');
    setEditingKey(null);
  } catch (error) {
    console.error('Error saving data:', error);
    alert(error.message);
    setSaving(false);
  }
};
  
const handleEdit = (key) => {
  console.log("handleEdit function called");
  const selectedData = data[key];
  if (!selectedData) {
    alert("Record not found for editing.");
    return;
  }
  console.log("selectedData",selectedData);
  
  setHeading(selectedData.Heading);
  setMaterial(selectedData.Material);
  setSelectedClass(selectedData.Class);
  setQuantity(selectedData.Quantity.toString());
  setPerItem(selectedData.PerItemAmount);
  setTamount(selectedData.TotalAmount);
  setDate(selectedData.date);
  setRemark(selectedData.Remark);
  setTeacherName(selectedData.TeacherName); // Update this line
  setEditingKey(key);


};

const handleDelete = async (key) => {
  const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/inventory/outstock.json`;

  try {
    // Delete data from 
    const response = await fetch(url, {
      method: 'GET',
    });

    const data = await response.json();
    if (data) {
      const updatedData = { ...data };
      delete updatedData[key];

      const updateResponse = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (updateResponse.ok) {
        // Delete data from IndexedDB
        const db = await openIndexedDB();
        const transaction = db.transaction('inventory', 'readwrite');
        const store = transaction.objectStore('inventory');
        const request = store.get('outstock');

        request.onsuccess = async (event) => {
          const result = event.target.result;
          if (result) {
            const updatedResult = { ...result };
            const value = updatedResult.value;
            if (value) {
              delete value[key];
              updatedResult.value = value;
            }

            const putRequest = store.put(updatedResult);
            await putRequest;
            console.log('Data deleted from IndexedDB');
          }
        };

        request.onerror = (event) => {
          console.error('Error deleting data from IndexedDB:', event.target.error);
        };

        await transaction.complete;
      } else {
        console.error('Error deleting data:', updateResponse.statusText);
      }
    } else {
      console.error('No data found');
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
};

const handlePrint = () => {
  const printContent = document.querySelector('.modal-content');

  if (printContent) {
    const cloneContent = printContent.cloneNode(true);

    // Modify the cloned content as needed
    const otherDetails = cloneContent.querySelectorAll('p'); 
    otherDetails.forEach((p, index) => {
      if (index !== 0) { 
        p.style.fontWeight = 'normal'; 
      }
    });

    // Call the function to remove the last column from the first table in the cloned content
    removeLastColumnOnPrint(cloneContent);

    const printWindow = window.open('', '', 'height=800,width=600');
    printWindow.document.write(`
      <html>
        <head>
          <style>
            @page {
              size: A4 Potrait;
              margin: 5mm;
              padding: 15px;
              border: 1px solid black;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              font-size: 16px;
            }
            th, td {
              border: 1px solid black;
              text-align: center;
              padding: 5px;
            }
            td {
              font-size: 16px;
            }
            th {
              background-color:  rgb(166 214 245);
            }
            .print-button {
              display: none;
            }
            .school-header-container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .school-header2 {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex: 0 0 auto; /* Prevent this section from growing */
              margin-right: 10px;
            }
            .school-header2 img {
              max-height: 70px;
            }
            .school-header {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center; margin-left:-70px;
              flex: 1 1 auto; /* This makes the school header take available space */
            }
            .school-header h1 {
              font-size: 28px;
              margin: 5px 0;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .school-header .report-title {
              font-size: 20px;
              margin: 5px auto;
              font-weight: bold;
              border: 1px solid black;
              width: 220px;
              padding: 5px;
              text-align: center;
              border-radius: 10px;
              background-color: black;
              color: white;
            }
            .school-header .report-tit {
              font-size: 16px;
              margin: 5px auto;
              font-weight: bold;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="school-header-container">
            <div class="school-header2">
              ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
            </div>
            <div class="school-header">
              <div style="margin-left: 15px;">
                <h1>${schoolName}</h1>
                <div class="report-tit">
                  ${language === 'English' ? 'Taluka' : 'तालुका'} ${taluka}, ${language === 'English' ? 'District' : 'जिल्हा'} : ${jilha}
                </div>
                <div class="report-title">
                  ${language === "English" ?  "Stock Outward Report" : "जावक साठा अहवाल"}
                </div>
              </div>
            </div>
          </div>
          <style>
            .styled-table {
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
          </style>
          ${cloneContent.outerHTML}
        </body>
      </html>
`);
    printWindow.document.close(); 

    // Call the function to append the last column back after printing
    appendLastColumnOnPrint(cloneContent);
    printWindow.focus(); // Focus the new window
    printWindow.print(); // Trigger print
    printWindow.close(); // Close the print window after printing
  } else {
    console.error('Print content not found');
  }
};

function removeLastColumnOnPrint(cloneContent) {
  const tables = cloneContent.querySelectorAll('table'); // Get all tables in the cloned content
  tables.forEach(table => {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = 'none'; // Hide last column header
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = 'none'; // Hide last column data
      }
    });
  });
}


function appendLastColumnOnPrint(cloneContent) {
  const table = cloneContent.querySelector('table'); // Use the cloned content to find the table
  if (table) {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = '';
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = '';
      }
    });
  } else {
    console.error('Table not found in the cloned content');
  }
}
  const uniqueHeadings = data ? [...new Set(Object.values(data).map((item) => item?.Heading))] : [];


 const fetchSchoolName = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const schoolData = event.target.result;
          if (schoolData) {
            if (schoolData.schoolName) {
              setSchoolName(schoolData.schoolName);
            }
            if (schoolData.taluka) {
              setTaluka(schoolData.taluka);
            }
            if (schoolData.jilha) {
              setJilha(schoolData.jilha);
            }
            if (schoolData.schoolLogo) {
              setLogoURL(schoolData.schoolLogo);
            }
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
  fetchSchoolName();
}, [udiseNumber]);

console.log("udise",udiseNumber);


  return (
    <div className='main-content-of-page' style={{ padding: '20px' }}>
      <div style={{ border: '1px solid #ccc', width: '60%', margin: 'auto', marginTop: '10px', padding: '25px 30px ', borderRadius:'5px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
            
      <h3 style={{textAlign:'center',color:'#1B4332',fontWeight:'bold', marginBottom:'15px'}}>{language === "English" ? "Stock Outward" : "जावक साठा"}</h3>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
    
          
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Category:" : "कॅटेगरी:"}</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <select
      value={heading}
      onChange={(event) => {
        const selectedValue = event.target.value;
        if (selectedValue === "add-new-heading") {
          setShowPopup(true); // Show the popup for adding a new heading
        } else {
          setHeading(selectedValue); // Set the selected heading
        }
      }}
      style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
    >
     <option value="">{language === "English" ? "Select Category" : "कॅटेगरी निवडा"}</option>
     {categoryOptions.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
                  ))}
              </select>

            </div>


          </div>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Material" : "साहित्य"}</label>
            <select
              value={material}
              onChange={(event) => setMaterial(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            >
              <option value="">{language === "English" ? "Select Material" : "साहित्य निवडा"}</option>
              {materialOptions.map((mat, index) => (
                <option key={index} value={mat}>
                  {mat}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Class" : "वर्ग"}</label>
           
            <select id="classDropdown" value={selectedClass} onChange={handleClassChange} className="brown-dropdown dropdown" style={{ width: '100%', height:'35px'}}>
  <option value="">{language === "English" ? "Select" : "निवडा"}</option>
  {classes &&
    classes.map((cls, index) => (
      <option key={index} value={cls}>
        {cls}
      </option>
    ))}
</select>
          </div>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Teacher" : "शिक्षक"}</label>
            <input
              type='text'
              value={TeacherName}
              onChange={(event) => setTeacherName(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

          <div style={{ marginRight: "15px", width: "20%" }}>
  <label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "10px", width: "100%" }}>
    {language === "English" ? "Quantity" : "प्रमाण"}
  </label>
  <input
    type="number"
    value={quantity}
    onChange={handleQuantityChange}
    placeholder={totalQuantityInStock !== null ? `Max: ${totalQuantityInStock}` : "Loading..."} // ✅ Shows only "Max: X"
    style={{
      padding: "6px",
      fontSize: "14px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      width: "100%",
    }}
  />
</div>


        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          {/* <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Per Item Amount" : " रक्कम"}</label>
            <input
              type='number'
              value={peritem}
              onChange={(event) => setPerItem(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div> */}

          {/* <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Total Amount" : "एकूण रक्कम"}</label>
            <input
              type='number'
              value={tamount}
              onChange={(event) => setTamount(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div> */}
          {/* <div style={{  marginRight: '15px',width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Provider" : "पुरवणारा"}</label>
            <input
              type='text'
              value={provider}
              onChange={(event) => setprovider(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div> */}
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Date" : "तारीख"}</label>
            <input
              type='date'
              value={date}
              onChange={(event) => setDate(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Remark" : "टिप्पणी"}</label>
            <input
              type='text'
              value={remark}
              onChange={(event) => setRemark(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
        </div>
        <div style={{
          textAlign: 'center'
        }}>
          <button type="button" onClick={handlesave} style={buttonStyle}>
            {saving ? 'Saving...' : 'Save'}
          </button>

          <button type="button" onClick={handlePrint} style={buttonStyleReport}>
          {language === "English" ? "Print" : "प्रिंट "}
        </button>
    
        </div>
      </div>

{showModal && (
            <div style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '10px',
              width: '100%',
              maxWidth: '1200px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.7)',
              maxHeight: '100%',
              position: 'relative', margin:'40px auto'
            }}>

              <div className="modal-content p-3" style={{border:'1px solid black'}}>
              <h5 className='h3classforschol' style={{textAlign:'center',color:'#1B4332',fontWeight:'bold', marginBottom:'5px'}}>{language === "English" ? "Stock Outward": "जावक साठा"}</h5>
      {heading ? (
  <div>
    <label style={{ marginLeft: "5px", marginTop: '10px' }}>{language === "English" ? "Category:" : "कॅटेगरी:"} {heading}</label>
    <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  marginBottom: '30px',
                  fontFamily: 'Arial, sans-serif',
                  border: '1px solid black',
                  borderRadius: '10px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}>
      <thead>
        <tr>
          <th className='firthtd' style={{ fontWeight:'bold', border: '1px solid black', padding: '6px 4px', textAlign: "center" }}>{language === "English" ? "Sr. No." : "अ.क्र."}</th>
          <th style={{fontWeight:'bold', border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Material" : "साहित्य"}</th>
          <th style={{ fontWeight:'bold', border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Class" : "वर्ग"}</th>
          <th style={{ fontWeight:'bold', border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Teacher" : "शिक्षक"}</th>
          <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Quantity" : "प्रमाण"}</th>
          <th style={{ fontWeight:'bold', border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Date" : "तारीख"}</th>
          <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Remark" : "टिप्पणी"}</th>
          <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center", width: '100px' }}>{language === "English" ? "Action" : "कृती"}</th>
        </tr>
      </thead>
      <tbody>
        {data && Object.keys(data)
          .filter(key => data[key] && data[key].Heading === heading && key !== "0") // Filter by selected heading, check if data[key] is not null, and key is not equal to "0"
          .filter(key => {
            const item = data[key];
            // Exclude rows where all values are null or empty
            return (
              item && (
                item.Material ||
                item.Class ||
                item.TeacherName ||
                item.provider ||
                item.Quantity ||
                item.PerItemAmount ||
                item.TotalAmount ||
                item.date ||
                item.Remark
              )
            );
          })
          .map((key, index) => (
            <tr key={index}>
              <td className='firthtd' style={{ border: '1px solid black', padding: '6px 4px', }}>{index+1}</td>
              <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Material}</td>
              <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Class}</td>
              <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.TeacherName}</td>
              <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Quantity}</td>
              <td style={{ border: '1px solid black', padding: '6px' }}>{formatDate(data[key]?.date)}</td>
              <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Remark}</td>
              <td style={{ border: '1px solid black', display: 'flex', justifyContent: 'space-between', width: '100px' }}>
                <button style={{ padding: '5px', fontSize: '16px', border: 'none', backgroundColor: 'blue', color: 'white', marginRight: '10px' }} onClick={() => handleEdit(key)}><i class="fa-solid fa-pen-to-square"></i></button>
                <button style={{ padding: '5px', fontSize: '16px', border: 'none', backgroundColor: 'red', color: 'white' }} onClick={() => handleDelete(key)}><i class="fa-regular fa-trash-can"></i></button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
) : (
  // Display all tables when no heading is selected
  uniqueHeadings.map((heading, index) => {
  const filteredData = Object.keys(data)
    .filter(key => data[key] && data[key].Heading === heading && key !== "0") // Filter by heading
    .filter(key => {
      const item = data[key];
      // Exclude rows where all values are null or empty
      return (
        item && (
          item.Material ||
          item.Class ||
          item.TeacherName ||
          item.provider ||
          item.Quantity ||
          item.PerItemAmount ||
          item.TotalAmount ||
          item.date ||
          item.Remark
        )
      );
    });

  // Only render the table if there is data for the heading
  if (filteredData.length > 0) {
    return (
      <div key={index}>
        <label style={{ marginLeft: "5px", marginTop: '10px' }}>{language === "English" ? "Category: " : "कॅटेगरी:"} {heading}</label>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '30px',
          fontFamily: 'Arial, sans-serif',
          border: '1px solid black',
          borderRadius: '10px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        }}>
          <thead>
            <tr>
              <th className='firthtd' style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 4px', textAlign: "center" }}>{language === "English" ? "Sr. No." : "अ.क्र."}</th>
              <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Material" : "साहित्य"}</th>
              <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Class" : "वर्ग"}</th>
              <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Teacher" : "शिक्षक"}</th>
             <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Quantity" : "प्रमाण"}</th>
              <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Date" : "तारीख"}</th>
              <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center" }}>{language === "English" ? "Remark" : "टिप्पणी"}</th>
              <th style={{fontWeight:'bold',  border: '1px solid black', padding: '6px 5px' , textAlign: "center", width: '80px' }} className="action-header">{language === "English" ? "Action" : "कृती"}</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((key, index) => (
              <tr key={index}>
                <td className='firthtd' style={{ border: '1px solid black', padding: '6px 4px', }}>{index+1}</td>
                <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Material}</td>
                <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Class}</td>
                <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.TeacherName}</td>
                <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Quantity}</td>
                <td style={{ border: '1px solid black', padding: '6px' }}>{formatDate(data[key]?.date)}</td>
                <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Remark}</td>
                <td style={{ border: '1px solid black', width: '80px' }} className="action-column">
                  <div style={{ display: 'flex' }}>
                    <button style={{ padding: '5px', fontSize: '18px', border: 'none', backgroundColor: 'transparent', color: '#8A1538', marginRight: '10px' }} onClick={() => handleEdit(key)}><i className="fa-solid fa-pen-to-square"></i></button>
                    <button style={{ padding: '5px', fontSize: '18px', border: 'none', color: 'red', backgroundColor: 'transparent' }} onClick={() => handleDelete(key)}><i className="fa-regular fa-trash-can"></i></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  return null; // Return null if there's no data for this heading
})
)}
<style jsx>{`

  .action-header{
    background-color:'#e9e9e9';
    font-weight:'bold';
  }
 @media print {
   th{
        padding-left:4px;
        padding-right:4px;
        text-align:center;
    }
td{
        text-align:center;
    }
    .h3classforschol{
    display:none;
    }
 }
`}</style>

</div>
</div> )}



</div>

  );
}

export default Outstock;

const buttonStyleReport= {
  marginTop: '20px',
  padding: '8px 16px',
  fontSize: '14px',
  backgroundColor: '#d4a017',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  marginLeft:'20px',
  right:'0',
  float:'right'
}
const buttonStyle = {
  marginTop: '20px',
  padding: '8px 20px',
  fontSize: '14px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};